// What the booking screen says about what happens next (LAUNCH-CHECKLIST H9, 13/10/2026).
//
// `outcome` comes from POST /leave-limits/check — the same rules check the booking route
// runs — as { kind: 'auto' | 'approval' | 'instant' | 'recorded', approver, why_not }.
// Pinned by bookingOutcome.checks.mjs. Dates DD/MM/YYYY (CONVENTIONS.md).
import { formatDateGB } from './dates.js';

/** Where an approver's name would go, for a request that approved itself. */
export const APPROVED_AUTOMATICALLY = 'Automatically, within the rules';

/** The approver to show for a request — a person's name, or the words above. When an API key
 *  approved it, the words the server stored: "Rob Hepworth (via API key 'HR sync')"
 *  (DESIGN-api-and-webhooks.md step 3, Rob's E A). */
export function approvedBy(req) {
  if (req && req.auto_approved) return APPROVED_AUTOMATICALLY;
  return (req && (req.actioned_via || req.actioned_by_name)) || null;
}

/** "Booked by" — only for a booking an API key made; null for everything made in the app
 *  (the app never said who booked, and step 3 doesn't start now). */
export function bookedBy(req) {
  return (req && req.booked_via) || null;
}

/** The toast after a booking that approved itself. */
export function bookedMessage(booking, forName) {
  const start = formatDateGB(booking?.start_date);
  const end = formatDateGB(booking?.end_date);
  const when = !end || end === start ? `on ${start}` : `${start} to ${end}`;
  const who = forName ? `${forName} is` : "you're";
  return `Approved: ${who} booked off ${when}.`;
}

/** The line under the days preview, or null for nothing new to say. */
export function outcomeLine(outcome) {
  if (!outcome) return null;
  if (outcome.kind === 'auto') {
    return { tone: 'auto', text: "Approved straight away: it's within all the rules." };
  }
  // Only worth saying when the type IS automatic but this request still needs a person —
  // otherwise it goes to the approver exactly as it always has.
  if (outcome.kind === 'approval' && outcome.why_not) {
    return { tone: 'info', text: `Goes to ${outcome.approver || 'your approver'}: ${outcome.why_not}.` };
  }
  return null;
}

/** The last line of the red "breaks a company rule" box. */
export function exceptionLine(outcome) {
  const who = outcome && outcome.approver;
  return who
    ? `You can still ask. It'll go to ${who}, who will see it's an exception.`
    : "You can still ask — your approver will see it's an exception.";
}

/** The submit button. */
export function submitLabel(outcome) {
  return outcome && outcome.kind === 'auto' ? 'Book it' : 'Submit request';
}
